import React from "react"
import FieldCRMAccount_PopoverMore from "./components/popover/popover-more"
import FieldDropdownDynamic from "../../../../fields3/generic/dropdown-dynamic/dropdown-dynamic"
import FieldConfig from "../../../proto/field-config"
import FieldAccountType_GlistGroupStandard from "./components/glist-group/standard"
import FieldCrmAccount_View from "./render/view"
import ItemModel from "../../../../model2/item/item-model"
import TableManager from "../../../../gd-modules/table/manager/table-manager"
import TaskListManager from "../../../../gd-modules/task-list/manager/manager"
import FieldCrmAccount_TableCell from "./render/table/table-cell"
import ModelEntity from "../../../../model2/model-entity"
import {EntityType} from "../../../../gd/const/item"
import Task from "../../../../model2/task/task"
import Project from "../../../../model2/project/project"

export default class FieldCrmAccount extends FieldDropdownDynamic {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Account";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','No account');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-account';

        this.isSearchable = true;

        this.components = _.assign({}, this.components, {
            PopoverMenuMore     : FieldCRMAccount_PopoverMore,
            ValueIcon           : <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>,

            glistGroupStandard  : FieldAccountType_GlistGroupStandard,
        })

        this.renderComponents.view      = FieldCrmAccount_View
        this.renderComponents.tableCell = FieldCrmAccount_TableCell
    }

    tableCellOnValueChange = async (item:ItemModel, value:any|null, manager:TableManager|TaskListManager) => {

        item.task.crmAccountId = value ? value : null
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // Aggregated values...
        // manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }

    getCsvValue(model:any) {
        const option = this._getOption(model[this.fieldId]);
        return option ? option.label : '';
    }

    getOptions() {

        if (!this._options) {

            if (gd.session._crmAccounts) {
                this._options = gd.session._crmAccounts.exportToOptions()
            } else {
                console.error("Try access session.crmAccounts but not initialized #jd932")
                return []
            }

        }

        return this._options
    }

    groupLabel(value: any): string {
        const option = this._getOption(value)
        return option ? option.label : this.noValueOptionLabel
    }

    getGraphColor(model: any, params: any): string {
        const option = this._getOption(this.getViewValue(model))
        return option ? "#"+gd.utils.nameColor(option.label) : super.getGraphColor(model, params)
    }

    canEdit(model:ModelEntity):boolean {
        switch (model.itemType) {
            case EntityType.TASK:
                return !(model as Task).isCrmAccountFromProject

            case EntityType.PROJECT:
                return !(model as Project).isCRMAccountInherited
        }

        return super.canEdit(model)
    }
}
